import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import { FormRule } from 'antd';
import { ValidateErrorEntity } from 'rc-field-form/lib/interface';

export const requiredRules: FormRule[] = [
  { required: true, message: 'Обязательное поле' },
];

type ErrorFieldsStatus = ReturnType<typeof useErrorFieldsStatus>;
const errorFieldsContext = createContext<ErrorFieldsStatus>({
  errorFields: [],
  setErrorFields: () => {},
  getFieldStatus: () => '',
  reset: () => {},
});

export const ErrorFieldsStatusProvider = errorFieldsContext.Provider;

export const useErrorFieldsStatusContext = () => {
  return useContext(errorFieldsContext);
};

export const useErrorFieldsStatus = () => {
  const [errorFields, setErrorFields] = useState<
    ValidateErrorEntity['errorFields']
  >([]);

  const getFieldStatus = useCallback(
    (field: string | string[]) => {
      const foundField = errorFields.find((f) => {
        if (Array.isArray(field)) {
          return f.name.join('.') === field.join('.');
        }

        return f.name[0] === field;
      });

      return foundField?.errors && foundField?.errors.length > 0 ? 'error' : '';
    },
    [errorFields]
  );

  const reset = useCallback(() => {
    setErrorFields([]);
  }, []);

  const result = useMemo(
    () => ({
      errorFields,
      setErrorFields,
      getFieldStatus,
      reset,
    }),
    [errorFields, getFieldStatus, reset]
  );

  return result;
};
